/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnersdownloadpng2Inputs */

const en_partnersdownloadpng2 = /** @type {(inputs: Partnersdownloadpng2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download PNG`)
};

const de_partnersdownloadpng2 = /** @type {(inputs: Partnersdownloadpng2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG herunterladen`)
};

/**
* | output |
* | --- |
* | "Download PNG" |
*
* @param {Partnersdownloadpng2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnersdownloadpng2 = /** @type {((inputs?: Partnersdownloadpng2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnersdownloadpng2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnersdownloadpng2(inputs)
	return de_partnersdownloadpng2(inputs)
});
export { partnersdownloadpng2 as "partnersDownloadPng" }